/**
 * @fileoverview Document name translation utilities
 * Maps backend document names to their translated versions
 */

import { intl } from "dmsbasereact";

/**
 * Map backend document names to translation keys
 */
const DOCUMENT_NAME_KEYS = {
    'CRT': 'Doc.CRT',
    'Sanitary Permit': 'Doc.SanitaryPermit',
    'CNPJ': 'Doc.CNPJ',
    'AFE': 'Doc.AFE',
    'AE': 'Doc.AE',
    'Book Evidence': 'Doc.BookEvidence',
    'CNES': 'Doc.CNES',
    // Return documents
    'evidencia': 'Doc.Evidencia',
    'laudo': 'Doc.Laudo',
    'proof': 'Doc.Proof',
    'invoice': 'Doc.Invoice',
    'other': 'Doc.Other',
    'other1': 'Doc.Other',
    'other2': 'Doc.Other',
    'evidencia1': 'Doc.Evidencia1',
    'evidencia2': 'Doc.Evidencia2',
    'evidencia3': 'Doc.Evidencia3',
};

/**
 * Reverse map: translated document names (all locales) → English key.
 * Used to normalize document names stored in the DB with translated values.
 */
const TRANSLATED_TO_KEY = {
    // pt_BR translations
    'Alvará Sanitário': 'Sanitary Permit',
    'Livro de Evidências': 'Book Evidence',
    // es_MX translations
    'Permiso Sanitario': 'Sanitary Permit',
    'Libro de Evidencias': 'Book Evidence',
};

/**
 * Get translated document name
 * @param {string} docName - Backend document name (e.g., 'CRT', 'Sanitary Permit')
 * @returns {string} Translated document name or original if no translation found
 */
export const getTranslatedDocumentName = (docName) => {
    if (!docName) return intl.get("Document").d("Document");
    const translationKey = DOCUMENT_NAME_KEYS[docName];
    if (translationKey) {
        return intl.get(translationKey).d(docName);
    }
    return docName;
};

/**
 * Normalize a document name to the canonical English key.
 * Handles document names stored in the DB with translated values (e.g., "Alvará Sanitário" → "Sanitary Permit").
 * @param {string} docName - Document name (may be English key or translated)
 * @returns {string} The canonical English key, or the original name if no mapping found
 */
export const normalizeDocumentName = (docName) => {
    if (!docName) return docName;
    if (DOCUMENT_NAME_KEYS[docName]) return docName;
    return TRANSLATED_TO_KEY[docName] || docName;
};
